import {Activities, Animals, Cameras, CollarLogs, Collars, Commands, ConfigurationDevices, DataLoggers, DropOffs, ESRI, ExternalSensors, GPSPositions, MarkerIcon, Mortalities, MortalityImplants, Movebank, Notifications, OldAnimals, OldCollars, OldDeployments, PaymentInformation, Proximities, ScheduleTemplates, Separations, TT4Sensors, TrapEvents, Traps, Users, VaginalImplants, VirtualFenceEvents, Items, Events} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public Activities: Activities,
    public Animals: Animals,
    public Cameras: Cameras,
    public CollarLogs: CollarLogs,
    public Collars: Collars,
    public Commands: Commands,
    public ConfigurationDevices: ConfigurationDevices,
    public DataLoggers: DataLoggers,
    public DropOffs: DropOffs,
    public ESRI: ESRI,
    public ExternalSensors: ExternalSensors,
    public GPSPositions: GPSPositions,
    public MarkerIcon: MarkerIcon,
    public Mortalities: Mortalities,
    public MortalityImplants: MortalityImplants,
    public Movebank: Movebank,
    public Notifications: Notifications,
    public OldAnimals: OldAnimals,
    public OldCollars: OldCollars,
    public OldDeployments: OldDeployments,
    public PaymentInformation: PaymentInformation,
    public Proximities: Proximities,
    public ScheduleTemplates: ScheduleTemplates,
    public Separations: Separations,
    public TT4Sensors: TT4Sensors,
    public TrapEvents: TrapEvents,
    public Traps: Traps,
    public Users: Users,
    public VaginalImplants: VaginalImplants,
    public VirtualFenceEvents: VirtualFenceEvents,
    public Items: Items,
    public Events: Events,
  ) {}
}